import { getImagePath } from "../utils/imageUtils";
import { FaPhoneAlt } from "react-icons/fa";
import { TfiTime } from "react-icons/tfi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { GoArrowRight } from "react-icons/go";
import { Link } from "react-router-dom";

type AvailabilitySectionProps = {
  contact: string | undefined;
  imageSrc: string;
  imageAlt?: string;
};

export default function AvailabilitySection({
  imageSrc,
  imageAlt = "Zariadenie na prenájom",
  contact,
}: AvailabilitySectionProps) {
  return (
    <section className="relative overflow-hidden self-stretch w-full rounded-lg">
      <div className="mx-auto max-w-6xl bg-custom-white px-3 shadow-md sm:px-8 lg:px-14 py-8">
        <div className="flex flex-col items-center gap-10">
          {/* TEXT */}
          <div className="flex flex-col z-10 text-center lg:text-left">
            <h2 className="text-2xl font-bold uppercase leading-tight tracking-wide text-[#123A63]">
              Preverte dostupnosť zariadení
            </h2>

            <div className="mx-auto mt-5 h-1 w-20 rounded-full bg-[#F4B13D] lg:mx-0" />

            <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-[#27445D] lg:mx-0">
              Zavolajte nám a overte si dostupnosť vybraného zariadenia.
            </p>

            {/* BENEFITS */}
            <div className="mt-8 grid grid-cols-3 overflow-hidden rounded-2xl bg-white shadow-lg ring-1 ring-custom-blue-500">
              <div className="flex flex-col items-center gap-3 border-r border-custom-blue-500 px-2 py-5">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#FFE6AA] text-custom-atrament">
                  <TfiTime className="h-6 w-6" />
                </div>
                <span className="text-center text-sm font-medium text-[#123A63] sm:text-base">
                  Rýchla odpoveď
                </span>
              </div>

              <div className="flex flex-col items-center gap-3 border-r border-custom-blue-500 px-2 py-5">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#FFE6AA] text-custom-atrament">
                  <TfiHeadphoneAlt className="h-6 w-6" />
                </div>
                <span className="text-center text-sm font-medium text-[#123A63] sm:text-base">
                  Odborné poradenstvo
                </span>
              </div>

              <div className="flex flex-col items-center gap-3 px-2 py-5">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#FFE6AA] text-custom-atrament">
                  <FaRegCircleCheck className="h-6 w-6" />
                </div>
                <span className="text-center text-sm font-medium text-[#123A63] sm:text-base">
                  Overená dostupnosť
                </span>
              </div>
            </div>
            <div
              className="flex justify-center
                   items-center w-full"
            >
              {" "}
              <a
                href={`tel:${contact}`}
                className="
                w-full
                group
                bg-custom-atrament
                md:hover:bg-custom-red
                border border-custom-red/30
                md:hover:border-custom-red
                rounded-lg
                shadow-md
                px-3
                py-2
                flex
                items-center
                justify-center
                mt-4
                transition-all
                duration-300
              "
              >
                <div
                  className="
                  rounded-full
                  bg-[#F4B13D]
                  md:group-hover:bg-custom-white
                  p-2
                  transition-colors
                  duration-300
                "
                >
                  <FaPhoneAlt className="text-lg text-custom-white md:group-hover:text-custom-red" />
                </div>

                <span
                  className="
                  ml-3
                  text-lg
                  font-semibold
                  text-custom-white
                  md:group-hover:text-custom-white
                  transition-colors
                  duration-300
                "
                >
                  {contact}
                </span>
              </a>
            </div>
          </div>

          {/* IMAGE */}
          {/* <div className="relative mx-auto w-full max-w-xl lg:max-w-none">
            <div className="absolute inset-6 rounded-[3rem] bg-[#F1F5F9]" />

            <div className="absolute right-4 top-12 hidden grid-cols-6 gap-2 opacity-60 sm:grid">
              {Array.from({ length: 36 }).map((_, index) => (
                <span
                  key={index}
                  className="h-1.5 w-1.5 rounded-full bg-[#F4B13D]"
                />
              ))}
            </div>

            <img
              src={getImagePath(imageSrc)}
              alt={imageAlt}
              className="relative z-10 mx-auto w-full w-[70%] object-contain"
            />
          </div> */}
          <div className="relative mx-auto w-full max-w-xl lg:max-w-none">
            <div className="absolute inset-6 rounded-[3rem] bg-[#F1F5F9]" />

            <div className="absolute right-4 top-12 hidden grid-cols-6 gap-2 opacity-60 sm:grid">
              {Array.from({ length: 36 }).map((_, index) => (
                <span
                  key={index}
                  className="h-1.5 w-1.5 rounded-full bg-[#F4B13D]"
                />
              ))}
            </div>

            <img
              src={getImagePath(imageSrc)}
              alt={imageAlt}
              className="relative z-10 mx-auto w-full w-[70%] object-contain"
            />

            {/* Gallery button */}
            <Link
              to="/o-rentkos-spolocnosti#gallery"
              className="group absolute bottom-4 right-4 z-20 inline-flex items-center gap-2 rounded-lg bg-white/90 px-4 py-2 text-sm font-medium text-[#203F63] shadow-md backdrop-blur transition-all duration-200 hover:-translate-y-0.5 hover:bg-white hover:shadow-lg"
            >
              <span>Galéria</span>
              <GoArrowRight className="text-lg" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
